function $59de1b3cb903d80b$var$showMenu(navLinks) {
    if (navLinks.classList.contains("hidden")) navLinks.classList.toggle("hidden");
    navLinks.classList.add("flex");
}
function $59de1b3cb903d80b$var$closeMenu(navLinks) {
    navLinks.classList.add("hidden");
    if (navLinks.classList.contains("flex")) navLinks.classList.toggle("flex");
}
function $59de1b3cb903d80b$export$2e2bcd8739ae039() {
    const navLinks = document.getElementById("section-links");
    const menu = document.getElementById("menu-icon");
    const exit = document.getElementById("exit-icon");
    menu.addEventListener("pointerdown", function() {
        if (navLinks.classList.contains("hidden")) navLinks.classList.toggle("hidden");
        navLinks.classList.add("flex");
    });
    exit.addEventListener("pointerdown", function() {
        navLinks.classList.add("hidden");
        if (navLinks.classList.contains("flex")) navLinks.classList.toggle("flex");
    });
}


function $f9f7990743c7a5b4$var$updateIndex(curInd, prevInd) {
    const ind1 = document.getElementById("spot-ind-1");
    const ind2 = document.getElementById("spot-ind-2");
    const ind3 = document.getElementById("spot-ind-3");
    const ind4 = document.getElementById("spot-ind-4");
    const indices = [
        ind1,
        ind2,
        ind3,
        ind4
    ];
    indices[prevInd].style.fontWeight = "normal";
    indices[curInd].style.fontWeight = "bold";
}
function $f9f7990743c7a5b4$var$updateSpotlight(curProj, prevProj) {
    const sp1 = document.getElementsByClassName("spot1");
    const sp2 = document.getElementsByClassName("spot2");
    const sp3 = document.getElementsByClassName("spot3");
    const sp4 = document.getElementsByClassName("spot4");
    const spotlights = [
        sp1[0],
        sp2[0],
        sp3[0],
        sp4[0]
    ];
    $f9f7990743c7a5b4$var$updateIndex(curProj, prevProj);
    spotlights[prevProj].classList.add("hidden");
    spotlights[curProj].classList.remove("hidden");
}
function $f9f7990743c7a5b4$export$2e2bcd8739ae039() {
    const numProjects = 4;
    let currentProj = 0;
    const arrowLeft = document.getElementById("spotlight-arrow-left");
    const arrowRight = document.getElementById("spotlight-arrow-right");
    const ind1 = document.getElementById("spot-ind-1");
    const ind2 = document.getElementById("spot-ind-2");
    const ind3 = document.getElementById("spot-ind-3");
    const ind4 = document.getElementById("spot-ind-4");
    const indices = [
        ind1,
        ind2,
        ind3,
        ind4
    ];
    arrowLeft.addEventListener("click", function() {
        let previousProj = currentProj;
        currentProj = (currentProj + 3) % numProjects;
        $f9f7990743c7a5b4$var$updateSpotlight(currentProj, previousProj);
    });
    arrowRight.addEventListener("click", function() {
        let previousProj = currentProj;
        currentProj = (currentProj + 1) % numProjects;
        $f9f7990743c7a5b4$var$updateSpotlight(currentProj, previousProj);
    });
    for(let i = 0; i < 4; i++)indices[i].addEventListener("pointerdown", function() {
        let previousProj = currentProj;
        currentProj = Number(indices[i].innerHTML) - 1;
        $f9f7990743c7a5b4$var$updateSpotlight(currentProj, previousProj);
    });
}


function $158382c18ff0a1f6$var$toggleTheme() {
    const html = document.documentElement;
    const currentTheme = html.getAttribute("data-theme");
    const themedImages = document.getElementsByClassName("themed-image");
    const newTheme = currentTheme === "dark" ? "light" : "dark";
    html.setAttribute("data-theme", newTheme);
    localStorage.setItem("theme", newTheme);
    for(let i = 0; i < themedImages.length; i++)themedImages[i].classList.toggle("hidden");
}
function $158382c18ff0a1f6$export$2e2bcd8739ae039() {
    document.addEventListener("DOMContentLoaded", ()=>{
        const savedTheme = localStorage.getItem("theme") || "light";
        document.documentElement.setAttribute("data-theme", savedTheme);
        // set images for dark theme
        const themedImages = document.getElementsByClassName("themed-image");
        if (savedTheme == "dark") for(let i = 0; i < themedImages.length; i++)themedImages[i].classList.toggle("hidden");
    });
    document.getElementById("light-toggle").addEventListener("click", $158382c18ff0a1f6$var$toggleTheme);
    document.getElementById("dark-toggle").addEventListener("click", $158382c18ff0a1f6$var$toggleTheme);
}


window.addEventListener("load", ()=>{
    const preloader = document.getElementById("preloader");
    if (preloader) {
        setTimeout(()=>preloader.classList.add("fade-out"), 250);
        document.body.style.display = "block";
    }
});
(0, $59de1b3cb903d80b$export$2e2bcd8739ae039)();
var $35da740d59af89ba$var$path = window.location.pathname;
var $35da740d59af89ba$var$page = $35da740d59af89ba$var$path.split("/").pop();
if ($35da740d59af89ba$var$page !== "writing.html") (0, $f9f7990743c7a5b4$export$2e2bcd8739ae039)();
(0, $158382c18ff0a1f6$export$2e2bcd8739ae039)();


//# sourceMappingURL=index.02f8e8f6.js.map
